var RE=/(-ms-|-webkit-|-moz-|-o-)/g;export default function unprefixValue(value){return"string"==typeof value?value.replace(RE,""):value}